/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import styles from './status.module.scss';
import icon from '../../../../icons/certificate.svg';
import Loading from '../../../../components/loading';
import { getApplicationDetails } from '../../redux/action';

const Result = (props) => {
  const lmsData = useSelector(ele => (ele?.permitManagement?.userData?.lms));
  const categoryTraining = useSelector(ele => (ele?.permitManagement?.userData?.category_trainings));
  const actionApplicationDetails = useSelector(states => states?.permitManagement?.actionApplicationDetails);
  const { handelNavigation, translation, suportedLanguages, applicationDetails, enable_category_training, selectedCategory } = props;
  const updateDpAction = useSelector(state => state?.permitManagement?.actionUpdateDp);
  const [trainingData, setTrainingData] = useState([]);
  let selectedLanguageTraining= [];
  const { match } = props;
  const id = match?.params?.id;
  const ismyApplicationPath = match?.path?.includes('myapplications/start');
  const actionDispatch = useDispatch();
  const tracking_progress = useSelector(state => state?.permitManagement?.userData?.permit);

  useEffect(() => {
    let storedLanguage = JSON.parse(localStorage.getItem('adpLanguage') || '{}')?.name;
    const localData = JSON.parse(localStorage.getItem(id) || '{}');
    if (!storedLanguage) {
      storedLanguage = localData?.selectedLanguage;
    }
    const metaLangKey = Object.keys(applicationDetails?.permit?.meta_data?.application_meta?.adp_language || {})[0];
    const translationLang = translation?.name;
    const selectedLanguage = suportedLanguages?.find(
      ele => ele.name === storedLanguage || ele.name === metaLangKey || ele.name === translationLang
    );
    if (selectedLanguage) {
      const name=`${selectedLanguage.name.slice(0, 1).toUpperCase()}${selectedLanguage.name.slice(1)}`;
      if (enable_category_training === true) {
        const lang = `${selectedLanguage.name.slice(0, 1).toLowerCase()}${selectedLanguage.name.slice(1)}`;
        selectedLanguageTraining= categoryTraining?.[lang]?.[selectedCategory] ? categoryTraining?.[lang]?.[selectedCategory] : [];
      } else {
        selectedLanguageTraining= lmsData?.[name]? lmsData?.[name] : lmsData?.English;
      }
    }
    setTrainingData([]);
    if (selectedLanguageTraining?.sections) {
      selectedLanguageTraining.sections.forEach((ele) => {
        ele.contents.forEach((el) => {
          if (el) setTrainingData(i => [...i, { ...el, additional_config: ele?.additional_config }]);
        });
      });
    }
  }, [props, lmsData, suportedLanguages, enable_category_training, categoryTraining, selectedCategory]);

  const handleGetAdpData = () => {
    actionDispatch(getApplicationDetails(tracking_progress?.id));
  };

  useEffect(() => {
    if (updateDpAction?.success === true && updateDpAction?.loading === false) {
      handleGetAdpData();
    }
  }, [updateDpAction]);


  const getSubComp = (data) => {
    let publicTestAttempts = JSON.parse(localStorage.getItem('testAttemps'));
    if (data?.additional_config?.whenQuizFail) {
      if (data?.additional_config?.whenQuizFail === 'Mandatory Wait Time until Test can be Retaken') {
        if (data?.additional_config?.no_of_days_to_mandate) {
          const diffTime = (new Date() - new Date(applicationDetails?.permit?.tracking_info?.quiz?.attempt_date)) / 1000;
          const mandateTimeInSec = Number(data?.additional_config?.no_of_days_to_mandate) * 24 * 60 * 60;
          if (diffTime > mandateTimeInSec) {
            return <div className={styles.failBtnContainer}>
                <div className={styles.downloadeButton}
                  style={{ width: 'auto', padding: '20px' }}
                  role="button"
                  tabIndex={0}
                  onClick={() => {
                    localStorage.setItem('currentIndex', 'true');
                    handelNavigation('training', 'training', 'fail');
                  }}
                  onKeyDown=""
                      >
                  <p style={{ fontSize: 'bold', margin: 0 }}>{translation.takeTrainingAgain}</p>
                </div>
                   </div>;
          }
          const timeLeft = mandateTimeInSec - diffTime;
          const days = Math.floor(timeLeft / (60 * 60 * 24));
          const hours = Math.floor((timeLeft % (60 * 60 * 24)) / (60 * 60));
          return (
          <p className={styles.p}>
            <FormattedMessage
              id="adp.permit.driver.test.fail.message"
              defaultMessage={`You will need to wait ${days} days and ${hours} hours to retake this test.`}
              values={{ days, hours }}
            />
          </p>
          );
        }
      } else if (data.additional_config?.whenQuizFail === 'Re-attempts Allowed') {
        const attemptsToConsider = applicationDetails?.permit?.tracking_info?.testAttempts ?? publicTestAttempts;
        if (attemptsToConsider < +data?.additional_config?.no_of_quiz_reattempts) {
        return (
        <>
        {!isLoading && (
          <p className={styles.p} style={{ marginTop: '0px' }}> You have {+data?.additional_config?.no_of_quiz_reattempts - (
            attemptsToConsider
          )}
          {' '} attempts remaining
          </p>
        )}
        <div className={styles.failBtnContainer}>
          <div className={styles.downloadeButton}
            style={{ width: 'auto', padding: '20px' }}
            role="button"
            tabIndex={0}
            onClick={() => {
              if (ismyApplicationPath) {
                handelNavigation('training', 'training', 'fail');
              } else {
                localStorage.setItem('currentIndex', 'true');
                handelNavigation('training', 'training', 'fail');
              }
            }}
            onKeyDown=""
          >
            <p style={{ fontSize: 'bold', margin: 0 }}>{translation.takeTestAgain}</p>
          </div>
        </div>
        </>
        );
        }
        if (data?.additional_config?.whenReattemptFail && data?.additional_config?.no_of_days_to_mandate_for_reattempts_failure
            && (applicationDetails?.permit?.tracking_info?.testAttempts >= +data?.additional_config?.no_of_quiz_reattempts
          || (publicTestAttempts && publicTestAttempts >= +data?.additional_config?.no_of_quiz_reattempts))) {
          const diffTime = (new Date() - new Date(applicationDetails?.permit?.tracking_info?.quiz?.attempt_date)) / 1000;
          const mandateTimeInSec = Number(data?.additional_config?.no_of_days_to_mandate_for_reattempts_failure) * 24 * 60 * 60;
          const timeLeft = mandateTimeInSec - diffTime;
          const days = Math.floor(timeLeft / (60 * 60 * 24));
          const hours = Math.floor((timeLeft % (60 * 60 * 24)) / (60 * 60));
            return (
            <p className={styles.p}>
              <FormattedMessage
                id="adp.permit.driver.test.fail.message"
                defaultMessage={`You will need to wait ${days} days and ${hours} hours to retake this test.`}
                values={{ days, hours }}
              />
            </p>
            );
          }
      }
    }
    return null;
  };

  const handleBackApplications = () => {
    const { isPortal, history, installationId } = props;
    if (isPortal) {
      history.push('/adp/myapplications');
    } else {
      localStorage.setItem('current_page', 'userApplications');
      history.push(`/auth/adp/login/${installationId}`);
    }
  };

  let isLoading = false;
  if (ismyApplicationPath) {
    isLoading = actionApplicationDetails?.loading;
  }

  return (
    <div className={styles.certificateContainer}>
      <Loading loadingStatus={isLoading} />
      <div className={styles.imgContainer}>
        <img src={icon} alt="certificate" className={styles.certificateImg} />
      </div>
      <h3 className={styles.h3}>
        {translation.oops}
        !
      </h3>
      <p className={styles.p}>{translation.failMsg}</p>
      {getSubComp(trainingData[0])}
      <div
        className={styles.applicationeButton}
        role="button" tabIndex={0}
        onClick={() => handleBackApplications()}
        onKeyDown={() => handleBackApplications()}>
          <p style={{ fontSize: 'bold', margin: 0 }}>Back to Applications</p>
      </div>
    </div>
  );
};

export default Result;
